export default function getUserSelector(state: Store): User {
    return state.client.user;
}
